//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import TitleSection from '~/components/atoms/Editorial/TitleSection.vue';
import SubtitleSection from '~/components/atoms/Editorial/SubtitleSection.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import TrendInspiration from '~/components/molecules/Editorial/Trend/TrendInspiration.vue';
export default {
  name: 'LargeImage',
  components: {
    TitleSection,
    SubtitleSection,
    SimpleParagraph,
    TrendInspiration
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload() {
      var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20;

      return {
        title: ((_ref20 = this.payload) != null ? (_ref20 = _ref20.primary) != null ? (_ref20 = _ref20.title) != null ? _ref20[0] : _ref20 : _ref20 : _ref20) || {},
        titleColor: ((_ref19 = this.payload) != null ? (_ref19 = _ref19.primary) != null ? _ref19.title_color : _ref19 : _ref19) || '',
        subtitle: ((_ref18 = this.payload) != null ? (_ref18 = _ref18.primary) != null ? (_ref18 = _ref18.subtitle) != null ? _ref18[0] : _ref18 : _ref18 : _ref18) || {},
        subtitleColor: ((_ref17 = this.payload) != null ? (_ref17 = _ref17.primary) != null ? _ref17.subtitle_color : _ref17 : _ref17) || '',
        paragraph: ((_ref16 = this.payload) != null ? (_ref16 = _ref16.primary) != null ? _ref16.paragraph : _ref16 : _ref16) || [],
        readMore: ((_ref15 = this.payload) != null ? (_ref15 = _ref15.primary) != null ? _ref15.read_more : _ref15 : _ref15) === 'Yes',
        background: ((_ref14 = this.payload) != null ? (_ref14 = _ref14.primary) != null ? _ref14.background_color : _ref14 : _ref14) || '',
        reference: ((_ref13 = this.payload) != null ? (_ref13 = _ref13.primary) != null ? _ref13.reference : _ref13 : _ref13) || '',
        image: {
          small: formatPrismicImage((_ref12 = this.payload) != null ? (_ref12 = _ref12.primary) != null ? (_ref12 = _ref12.image) != null ? _ref12.url : _ref12 : _ref12 : _ref12, ['w_375']) || EMPTY_PIXEL,
          medium: formatPrismicImage((_ref11 = this.payload) != null ? (_ref11 = _ref11.primary) != null ? (_ref11 = _ref11.image) != null ? _ref11.url : _ref11 : _ref11 : _ref11, ['w_375,dpr_2']) || EMPTY_PIXEL,
          large: formatPrismicImage((_ref10 = this.payload) != null ? (_ref10 = _ref10.primary) != null ? (_ref10 = _ref10.image) != null ? _ref10.url : _ref10 : _ref10 : _ref10, ['w_1440']) || EMPTY_PIXEL,
          xlarge: formatPrismicImage((_ref9 = this.payload) != null ? (_ref9 = _ref9.primary) != null ? (_ref9 = _ref9.image) != null ? _ref9.url : _ref9 : _ref9 : _ref9, ['w_1440,dpr_2']) || EMPTY_PIXEL,
          alt: ((_ref8 = this.payload) != null ? (_ref8 = _ref8.primary) != null ? _ref8.alt : _ref8 : _ref8) || ''
        },
        legend: ((_ref7 = this.payload) != null ? (_ref7 = _ref7.primary) != null ? _ref7.legend : _ref7 : _ref7) || '',
        layer: this.typeLayer(((_ref6 = this.payload) != null ? (_ref6 = _ref6.primary) != null ? _ref6.layer : _ref6 : _ref6) || ''),
        negativeText: this.negative(((_ref5 = this.payload) != null ? (_ref5 = _ref5.primary) != null ? _ref5.negative_text : _ref5 : _ref5) || ''),
        negativeIcon: this.negative(((_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? _ref4.negative_icon : _ref4 : _ref4) || ''),
        tracking: {
          data: {
            event_category: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? _ref3.event_category : _ref3 : _ref3) || '',
            event_action: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.event_action : _ref2 : _ref2) || '',
            event_label: ((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? _ref.event_label : _ref : _ref) || ''
          }
        }
      };
    }

  },
  methods: {
    negative(arg) {
      return arg === 'black';
    },

    typeLayer(arg) {
      return arg === 'no';
    }

  }
};